export default "__VITE_ASSET__BvcUMDWJ__"